export const postNameConstant = {
  /** 所属地区行政区划代码 */
  FCAREOBJECT: 'FCAREOBJECT',
  /** 求职意向地 */
  PLACE: 'place',
  /* 失业登记求职意向地:省级 */
  FINTENPROVINCE: 'FINTENPROVINCE',
  /** 失业登记求职意向地:市级 */
  FINTENCITY: 'FINTENCITY',
  /** 失业登记求职意向地:县级 */
  FFINTENCOUNTY: 'FFINTENCOUNTY',
  /** 我要就业求职意向地:市级 */
  FCAREOBJCITY: 'FCAREOBJCITY',
  /** 我要就业求职意向地:县级 */
  FCAREOBJCOUN: 'FCAREOBJCOUN',
  /** 户籍省/常住省 */
  PROVINCE: 'province',
  /** 户籍市/常住市 */
  CITY: 'city',
  /** 户籍区/常住区 */
  COUNTRY: 'country',
  /** 户籍镇/常住镇 */
  VILLAGE: 'village',
  /** 户籍村/常住村 */
  TOWN: 'town',
}